import { computed, inject, Injectable, signal } from "@angular/core";
import { I18n } from "@corporate/ng-tebis-base-components";
import { ProcessNavigationData } from "../../../02_ui/process-navigation/process-navigation.component";

@Injectable({
  providedIn: 'root'
})
export class ArticleNavbarService {

  i18n = inject(I18n);

  articleId = signal('');

  organizationExpanded = signal(false);

  processNavigationData = <ProcessNavigationData>{
    processGroups: [
      {
        label: this.i18n.translate('article:classification'),
        expanded: signal(true),
        processes: [
          {
            label: this.i18n.translate('article:analysisAndPreparation'),
            url: computed(() => `article/${this.articleId()}/part-analysis`),
            name: this.i18n.translate('article:analysisAndPreparation'),
            doneAutomatically: signal(true),
            doneManually: signal(true),
          },
          {
            label: this.i18n.translate('article:dataAcquisition'),
            url: computed(() => `article/${this.articleId()}/data-acquisition`),
            name: this.i18n.translate('article:dataAcquisition'),
            doneAutomatically: signal(false),
            doneManually: signal(false),
          },
        ],
      },
      {
        label: this.i18n.translate('article:manufacturingPlanning'),
        expanded: signal(false),
        processes: [
          {
            label: this.i18n.translate('article:manufacturingPlan'),
            doneAutomatically: signal(false),
            doneManually: signal(false),
          },
          {
            label: this.i18n.translate('article:friggelFactor'),
            doneAutomatically: signal(false),
            doneManually: signal(false),
          },
        ],
      },
      {
        label: this.i18n.translate('article:qualityManagement'),
        expanded: signal(false),
        processes: [
          {
            label: this.i18n.translate('article:incidentsAndNotes'),
            doneAutomatically: signal(false),
            doneManually: signal(false),
          },
          {
            label: this.i18n.translate('article:measurementProtocolsAndDocumentation'),
            doneAutomatically: signal(false),
            doneManually: signal(false),
          },
        ],
      },
      {
        label: this.i18n.translate('article:calculation'),
        expanded: signal(false),
        processes: [
          {
            label: this.i18n.translate('article:totalCalculation'),
            url: computed(() => `article/${this.articleId()}/calculation`),
            name: this.i18n.translate('article:totalCalculation'),
            doneAutomatically: signal(false),
            doneManually: signal(false),
          },
        ],
      },
    ],
  };
}